import { FC, useEffect, useRef, useState } from 'react';
import { isArray } from '@lhb/func';
// import { QuestionCircleOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import cs from 'classnames';
import IconFont from '@/common/components/IconFont';
// import LabelEdit from '../LabelEdit';
// import LabelEdit from './LabelEdit';
import { useMethods } from '@lhb/hook';
import Labels from './Labels';
import SelectLabelModal from '@/common/components/business/LabelDatabase/SelectLabelModal';

// const dataLimit = '2023年3月'; // 目前固定数据更新日期

/**
 * 获取标签行高度
 * @param rows 展示的标签行数，如果为 -1 则不限制行数
 */
const getHeight = (rows) => {
  if (rows === -1) {
    return '';
  }
  // 按实际标签高度调整，如果标签高度调整了，记得调整这里
  const tagHeight = 21;
  const tagGap = 6;
  return `${(tagHeight + tagGap) * rows - tagGap}px`;
};

/**
 * 商圈详情-标签行
 */
const LabelRow: FC<{
  id: number,
  /** 商圈详情 */
  detail: any,
  overViewData: any,
  /** 展示的标签行数 */
  rows?: number,
  /** 是否可编辑 */
  editable?: boolean,
  /** 是否可展开 */
  expandable?: boolean,
  /** 标签编辑后回调 */
  onLabelChanged?: any,
  labelOptionsChanged?: any,
  /** 分享页传入数据 */
  shareParams?,
  className?: any;
  style?: any;
}> = ({
  id,
  detail,
  overViewData,
  /** 展示的标签行数 */
  rows = 1,
  editable = true,
  expandable = true,
  onLabelChanged, // 标签编辑后回调
  labelOptionsChanged,
  shareParams,
  className,
  style,
}) => {

  const labelsRef = useRef<any>(null); // 标签ref
  const labelRef = useRef<any>(null); // 标签ref

  const [showExpandIcon, setShowExpandIcon] = useState<boolean>(false); // 是否展示收起按钮
  const [isFold, setIsFold] = useState<boolean>(true); // 标签行是否折叠，折叠情况下只展示一行

  // const [labelModal, setLabelModal] = useState<any>({ visible: false, id }); // 标签编辑弹窗
  const [modalData, setModalData] = useState<any>({ open: false, extraParams: {} }); // SelectLabelModal 状态
  /** 所有标签 */
  const [allLabels, setAllLabels] = useState<any[]>([]);
  const [customLabels, setCustomLabels] = useState<any[]>([]);

  useEffect(() => {
    setTimeout(() => {
      // 判断在非展开情况下，高度是否会超过可视高度
      setShowExpandIcon(labelRef?.current?.offsetHeight < labelRef?.current?.scrollHeight || !isFold);
    }, 100);
  }, [isFold, allLabels]);

  const methods = useMethods({

    updateLabels() {
      labelsRef.current?.reload();
    },

    handleEditLabel: (e) => {
      e.stopPropagation();
      // setLabelModal({
      //   visible: true,
      //   id,
      // });
      setModalData({ open: true, extraParams: {
        modelClusterId: id,
        labelType: 3, // 3自定义标签
        areaName: detail?.areaName
      } });
    },

    onChanged: () => {
      methods.updateLabels();
      onLabelChanged && onLabelChanged();
      labelOptionsChanged && labelOptionsChanged();
    },

    /** 展开标签 */
    handleExpand(e) {
      e.stopPropagation();
      setIsFold(!isFold);
    },

  });

  return (
    <>
      <div className={cs(styles.labelRow, 'mt-8', className)} style={style}>
        <div className={styles.labelRowWrap}>
          <Labels
            ref={labelsRef}
            labelRef={labelRef}
            detail={detail}
            overviewData={overViewData}
            shareParams={shareParams}
            style={{ height: getHeight(isFold ? rows : -1) }}
            updateAllLabels={setAllLabels}
            setCustomLabels={setCustomLabels}
          />
          {/* 编辑标签按钮 */}
          <div className={cs(styles.operations, showExpandIcon && styles.showExpandIcon)}>
            {isArray(allLabels) && !!allLabels.length && expandable && showExpandIcon
              ? <div className={styles.btn} onClick={methods.handleExpand}>
                <IconFont
                  iconHref='pc-common-icon-a-iconarrow_down'
                  className={isFold ? styles.arrowIcon : styles.arrowIconUp} style={{ color: '#979797' }}
                />
              </div> : <></>}
            {!!editable && <div className={styles.btn} onClick={methods.handleEditLabel}>
              <IconFont
                iconHref='pc-common-icon-ic_edit'
                style={{ color: '#979797' }}
              />
            </div>}
          </div>
        </div>
        {/* <div className={styles.rightExpand}>
          数据说明<QuestionCircleOutlined className={styles.questionIcon} onClick={() => setOpenDataInfo(true)} />
        </div> */}
      </div>

      {/* <LabelEdit
        visible={labelModal.visible}
        id={labelModal.id}
        setVisible={visible => setLabelModal((state: any) => ({ ...state, visible }))}
        optionsChanged={labelOptionsChanged}
        onChanged={methods.onChanged}
      /> */}
      <SelectLabelModal
        modalData={modalData}
        type={2}
        showLabels={customLabels}
        onSuccess={methods.onChanged}
        onClose={() => setModalData({ open: false, extraParams: {} })}
      />
    </>
  );
};

export default LabelRow;
